import SearchInput from '../../components/SearchInput';

import React from 'react';
const NFTDetails = () => {
  return (
    <div className="">
      <div className="grid grid-cols-2 mb-4">
        <h4 className="mb-2">Stored NFT&apos;s</h4>
        <div className="flex justify-end items-center">
          <div className="inline-flex relative">
            <SearchInput
              name="commonSearch"
              id="commonSearch"
              placeholder="Search project"
            />
          </div>
        </div>
      </div>
      <div className="w-full bg-brandGray px-8 py-4 rounded-xl">
        <div className="relative overflow-x-auto ">
          <table className="tableradus table-auto md:table-fixed lg:table-auto w-full text-sm text-left  border-separate border-spacing-y-3 shadow-none">
            <thead className="text-xs uppercase ">
              <tr>
                <th scope="col" className="px-6 py-3">
                  #
                </th>
                <th scope="col" className="px-6 py-3">
                  User Name
                </th>
                <th scope="col" className="px-6 py-3">
                  Wallet Address
                </th>
                <th scope="col" className="px-6 py-3">
                  No. of NFT&apos;s
                </th>
                <th scope="col" className="px-6 py-3">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className="bg-[#F3F3F3] ">
              <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 dark:text-white"
                >
                  01
                </td>
                <td
                  scope="row"
                  className="flex px-6 py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Sam Miller
                </td>
                <td className="px-6 py-4 text-blue-600">
                  0xa7013h...6a8722jnvjcxcvvv
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-semibold">100</span>
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-medium">
                    29 March 2022 | 12:26 AM{' '}
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 dark:text-white"
                >
                  02
                </td>
                <td
                  scope="row"
                  className="flex px-6 py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Sam Miller
                </td>
                <td className="px-6 py-4 text-blue-600">
                  0xa7013h...6a8722jnvjcxcvvv
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-semibold">100</span>
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-medium">
                    29 March 2022 | 12:26 AM{' '}
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 dark:text-white"
                >
                  03
                </td>
                <td
                  scope="row"
                  className="flex px-6 py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Sam Miller
                </td>
                <td className="px-6 py-4 text-blue-600">
                  0xa7013h...6a8722jnvjcxcvvv
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-semibold">100</span>
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-medium">
                    29 March 2022 | 12:26 AM{' '}
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 dark:text-white"
                >
                  04
                </td>
                <td
                  scope="row"
                  className="flex px-6 py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Sam Miller
                </td>
                <td className="px-6 py-4 text-blue-600">
                  0xa7013h...6a8722jnvjcxcvvv
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-semibold">100</span>
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-medium">
                    29 March 2022 | 12:26 AM{' '}
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 dark:text-white"
                >
                  05
                </td>
                <td
                  scope="row"
                  className="flex px-6 py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Sam Miller
                </td>
                <td className="px-6 py-4 text-blue-600">
                  0xa7013h...6a8722jnvjcxcvvv
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-semibold">100</span>
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-medium">
                    29 March 2022 | 12:26 AM{' '}
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 dark:text-white"
                >
                  06
                </td>
                <td
                  scope="row"
                  className="flex px-6 py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Sam Miller
                </td>
                <td className="px-6 py-4 text-blue-600">
                  0xa7013h...6a8722jnvjcxcvvv
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-semibold">100</span>
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-medium">
                    29 March 2022 | 12:26 AM{' '}
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700 mb-3 rounded-md overflow-hidden">
                <td
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 dark:text-white"
                >
                  07
                </td>
                <td
                  scope="row"
                  className="flex px-6 py-4 font-semibold text-gray-900 dark:text-white"
                >
                  Sam Miller
                </td>
                <td className="px-6 py-4 text-blue-600">
                  0xa7013h...6a8722jnvjcxcvvv
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-semibold">100</span>
                </td>
                <td className="px-6 py-4">
                  <span className=" inline-block font-medium">
                    29 March 2022 | 12:26 AM{' '}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default NFTDetails;
